import api from '@/api/api';
import {parseZodSchema} from '@/api/models/parseZodSchema';
import {deletedBookings, type DeletedBookings} from '@/api/models/booking/deletedBookings';

export function deleteBookingsByToken(token: string): Promise<DeletedBookings> {
    return api
        .delete(`/api/delete-bookings?token=${encodeURIComponent(token)}`)
        .then(api.handle)
        .then(raw => parseZodSchema(raw, deletedBookings));
}
